import React from "react";
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import { Button, Tooltip } from "@mui/material";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function CustomizedDialogs(props) {
  let { endDate,endTime } = props;

  function timeDiff(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(
      endDate + "T" + endTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    // const currentTime = moment();
    // const formattedTime = currentTime.format('HH:mm');
    const currentTime = new Date().toLocaleString('en-GB', { timeZone: `${timezone}` });
    const currentTime1 = currentTime.split(",");
    const formattedTime = currentTime1[1].substring(0, 6);
    
    
    const endTimeMoment = moment(endTime3, 'HH:mm');
    const formattedTimeMoment = moment(formattedTime, 'HH:mm');
    // const formattedTimeMoment = moment("12:45", 'HH:mm');

    const diffInMinutes = endTimeMoment.diff(formattedTimeMoment, 'minutes');

    const disableButton = diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}` && diffInMinutes >= 0;
    return disableButton;
  }

  const [open, setOpen] = React.useState(false);
  const [popupopen, setPopUpOpen] = React.useState(false);
  const [opentitle, setOpentitle] = React.useState();
  const [popupopentitle, setPopupOpentitle] = React.useState("Are you sure you want to stop a lab?.");

  const handleClose = () => {
    setOpen(false);
    setPopUpOpen(false);
  };

  const handlePopUpClose = () => {
    setPopUpOpen(false);
  };

  const handleOpen = () => {
    setPopUpOpen(true);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    window.location.reload();
    const InstanceID = localStorage.getItem("InstanceID");
    console.log("Bearer " + localStorage.getItem("token"));
    fetch(`${process.env.REACT_APP_API_URL}/api/stopcloudlab/${InstanceID}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data === "Success") {
            setOpen(false);
            window.location.reload();
          }
          else {
            setOpen(true);
            setOpentitle(data);
          }
        } else {
          if (data.name) {
            setOpen(false);
            setState({ errorMessage: data.name[0] });
          }
        }
      })
      .catch((error) => {
        setOpen(false);
        window.location.reload();
      });
  };

  return (
    <div>
      <Dialog
          open={popupopen}
          onClose={handlePopUpClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {popupopentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handlePopUpClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSubmitClick} color="primary">
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {opentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      <Tooltip title="Stop" arrow>
        <span>
      <Button
        sx={{ 
          mx: 1,
          height: { xs: '26px', sm: '30px' },
          width: { xs: '26px', sm: '30px' },
          minWidth: 'auto',
          marginBottom: "5px",
          marginTop: "-20px",
          borderRadius: '50px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          p: 0,
          '&.Mui-disabled': {
            bgcolor: 'action.disabledBackground',
            color: 'action.disabled',
            boxShadow: 'none'
          },
        }}
        variant="contained"
        disabled={ timeDiff(endDate,endTime) }
        onClick={handleOpen}
        aria-label="Stop"
      >
        <StopTwoToneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
      </Button>
        </span>
      </Tooltip>
    </div>
  );
}
